module.exports = __webpack_public_path__ + "static/media/fluids.175fe274.png";


//////////////////
// WEBPACK FOOTER
// ./src/resources/fluids.png
// module id = 475
// module chunks = 0